import "./App.css";
import BillContainer from "./components/BillContainer";

function App() {
  return (
    <div>
      <h1 className="header-title">
        SPLI
        <br />
        TTER
      </h1>
      <BillContainer />
    </div>
  );
}

export default App;
